import type { ReactNode } from 'react';
import { css } from 'styled-system/css';

export function FakeBtn({
  children,
  primary,
}: {
  children: ReactNode;
  primary?: boolean;
}) {
  return (
    <span
      className={css({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '28px',
        paddingInline: '3',
        fontSize: 'xs',
        fontWeight: 'semibold',
        background: primary ? 'accent.default' : 'bg.surface',
        color: primary ? 'text.onAccent' : 'text.secondary',
        border: primary
          ? '1px solid token(colors.accent.default)'
          : '1px solid token(colors.border.hairline)',
      })}
    >
      {children}
    </span>
  );
}
